import "../styles/IndicatorsStyle.css";
import { useState, useEffect } from "react";
import Select from "react-select";

import {
  handle_wmslink,
  handle_selected_data,
  getMonthName,
} from "../sidepane/Precipitation";
import Precipitation from "./Precipitation";
import Vegetation from "./Vegetation";
import Soil from "./Soil";
import GeographicBackground from "./GeographicBackground";
import ProtectedAreas from "./ProtectedAreas";
import CombinedHazard from "./CombinedHazard";
import CombinedForecast from "./CombinedForecast";
import {selection_component, handleInfoClickGeneral, oncheckGeneral, set_innitial_selected_datasets_general} from "./Utils";

import {get_data} from "../Geoportal"

export function get_custom_list(first_value, last_value, increment = 1) {
  var custom_list = [];
  for (var i = first_value; i <= last_value; i += increment) {
    custom_list.push(i);
  }
  const ListWithLeadingZeros = custom_list.map((num) => {
    return num.toString().padStart(2, "0");
  });

  return ListWithLeadingZeros;
}

export function get_num_withzero(num) {
  return num.toString().padStart(2, "0");
}

export function get_info_element(handleInfoClick){
  return (
    <span className="info-icon" onClick={handleInfoClick}>
      <span className="icon">
        <i className="fas fa-info-circle"></i>
      </span>
    </span>
  );
}

const Indicators = ({
  rs_data,
  precipitation_check,
  setPrecipitation_check,
  setCurrent_vector,
  setCurrent_spi,
  setSpi_legend_url,
  months,
  selected_spi_dates,
  setSelected_spi_dates,
  get_filtered_wms_spi,
  selected_country,
  get_years,
  setCurrent_fapar_anomaly,
  fapar_anomaly_check,
  setFapar_anomaly_check,
  get_filtered_wms,
  setFapar_anomaly_legend_url,
  fapar_absorbed_check,
  setFapar_absorbed_check,
  base_url,
  setCurrent_fapar_absorbed,
  setFapar_absorbed_legend_url,
  monthly_precipitation_check,
  setMonthly_recipitation_check,
  setCurrent_monthly_precipitation_gpcc,
  setGpcc_monthly_precipitation_legend_url,
  selected_region,
  setCurrent_sma,
  sma_check,
  setSma_check,
  setLegend_url_sma,
  setCurrent_cdi,
  cdi_check,
  setCdi_check,
  cdi_selected_dates,
  setCdi_selected_dates,
  request_str_modis_ndvi,
  setRequest_str_modis_ndvi,
   setCurrent_ndvi,
    ndvi_check,
    setNdvi_check,
    koppen_climate_clas_check, 
    setKoppen_climate_clas_check,
    current_protected_areas,
    setCurrent_protected_areas,
    protetect_areas_check, setProtetect_areas_check
    ,unwdc_check, setUnwdc_check,
     setCurrent_unwdc,
     setCurrent_spi_era5,
     checked_spi_era5, 
     setChecked_spi_era5,
    setCurrent_cdi_era5,
    cdi_era5_check,
  setCdi_era5_check,
  longrange_forecast_check,
   setLongrange_forecast_check,
   setCurrent_longrange_forecast,
   drought_persistence_check,
   setDrought_persistence_check,
   setCurrent_drought_persistence,
   combined_hazard_era5_check,
   setCombined_hazard_era5_check,
   setCurrent_combined_hazard_era5,
   combined_hazard_gpcc_check,
   setCombined_hazard_gpcc_check,
   setCurrent_combined_hazard_gpcc,
   combined_forecast_era5_check,
   setCombined_forecast_era5_check,
   setCurrent_combined_forecast_era5,
   combined_forecast_gpcc_check,
   setCombined_forecast_gpcc_check,
   setCurrent_combined_forecast_gpcc
}) => {
  const [cdi_dates, setCdi_dates] = useState({
    year: [2020, 2023],
    month: ["Nov", "Oct", "Sept"],
    dekad: ["1st", "2nd", "3rd"],
  });


  const [isDroughtModalVisible, setDroughtModalVisible] = useState(false);

  const [cdi_latest_dates, setCdi_latest_dates] = useState(null);
  const [cdi_info, setCdi_info] = useState(null);
  const [isLoadingCdiInfo, setIsLoadingCdiInfo] = useState(false);

  const [isDroughtModalVisibleCdiEra5, setDroughtModalVisibleCdiEra5] = useState(false);
  const [cdi_latest_dates_era5, setCdi_latest_dates_era5] = useState(null);
  const [cdi_info_era5, setCdi_info_era5] = useState(null);
  const [isLoadingCdiInfoEra5, setIsLoadingCdiInfoEra5] = useState(false);

  const [cdi_dates_era5, setCdi_dates_era5] = useState({
    year: [2025],
    month: ["Nov", "Oct", "Sept"],
    dekad: ["1st", "2nd", "3rd"],
  });
  const [cdi_selected_dates_era5, setCdi_selected_dates_era5] = useState({
    year: 2020,
    month: "Aug",
    dekad: "3rd",
  })

  const [drought_persistence_selected_dates, setDrought_persistence_selected_dates] = useState({ year: 2026, month: "Jan", dekad: "2nd" })
  const [drought_persistence_dates, setDrought_persistence_dates] = useState({
    year: [2025],
    month: ["Nov", "Oct", "Sept"],
    dekad: ["1st", "2nd", "3rd"],
  });
  const [drought_persistence_latest_dates, setDrought_persistence_latest_dates] = useState(null);
  const [DroughtPersistenceInfo, setDroughtPersistenceInfo] = useState(null);
  const [isLoadingDroughtPersistenceInfo, setIsLoadingDroughtPersistenceInfo] = useState(false);

  const [isDroughtModalVisibleDroughtPersistence, setDroughtModalVisibleDroughtPersistence] = useState(false);


  // vegetation props


  // geo bg props
  const [temp_class_check, setTemp_class_check] = useState(false);
  

  // utilities
  var months_list = Object.keys(months);
  var months_obj = months;

  var dekads_names = { "01": "1st", 11: "2nd", 21: "3rd" };

  var list_dekads = { "1st": "01", "2nd": "11", "3rd": "21" };

  var geoserver = `${base_url}/geoserver/wms?`;
  var maplibre_str =
    "bbox={bbox-epsg-3857}&format=image/png&service=WMS&version=1.1.1&request=GetMap&srs=EPSG:3857&width=256&height=256&transparent=true&layers=";
  var layer_name_cdi = "africa_drought_datasets:grid_01dd_cdi_";
  var layer_name_cdi_era5 = "africa_drought_datasets:grid_01dd_era5_cdi_";
  var layer_name_drought_persistence = "africa_drought_datasets:grid_01dd_drought_to_persist_cdi_";

  

  function get_dekad_name(dekad) {
    return dekads_names[dekad];
  }

  const handleInfoClick = () => {
    setDroughtModalVisible(!isDroughtModalVisible);
  
    if (!isDroughtModalVisible) { // Only fetch data if the modal is not already visible
      setIsLoadingCdiInfo(true); // Set loading state to true before fetching
      const url = `${base_url}/api/metadata/?dataset_id=cdi`;
      get_data(url).then((data) => {
        setCdi_info(data[0]);
        setIsLoadingCdiInfo(false); // Set loading state to false after fetching
      }).catch(error => {
        console.error('Failed to fetch CDI info:', error);
        setIsLoadingCdiInfo(false); // Ensure loading state is set to false even if there's an error
      });
    }
  };
  
  

  function set_initial_data(rs_data) {
    if (rs_data.hasOwnProperty("cdi")) {
      var cdi_data_from_api = rs_data.cdi;
      var latest_year = cdi_data_from_api.latest_year;
      var start_year = cdi_data_from_api.start_year;
      var latest_month = cdi_data_from_api.latest_month;
      var latest_dekad = cdi_data_from_api['latest_dekad'];

      var years = get_custom_list(start_year, latest_year);
      var months = get_custom_list(1, latest_month);
      var dekads = get_custom_list(1, latest_dekad, 10);
      var month_names = months.map(getMonthName);
      var dekad_names = dekads.map(get_dekad_name);

      var _month = get_num_withzero(latest_month);
      var _dekad = get_num_withzero(latest_dekad);

      var cdi_wms_url = `${geoserver}${maplibre_str}${layer_name_cdi}${_month}${_dekad}_view&CQL_FILTER=year=${latest_year}`;

      var cdi_wms_handled = handle_wmslink(
        cdi_wms_url,
        "cell",
        selected_country,
        selected_region
      );

      setCurrent_cdi({ cdi_geoserver: cdi_wms_handled });
      latest_dekad = get_num_withzero(latest_dekad)

      setCdi_selected_dates({
        year: latest_year,
        month: getMonthName(latest_month),
        dekad: get_dekad_name(latest_dekad),
      });

      setCdi_latest_dates({
        latest_year: latest_year,
        latest_month: latest_month,
        latest_dekad: latest_dekad,
      });

      setCdi_dates({
        year: years,
        month: month_names,
        dekad: dekad_names,
      });
    }
    // cdi era5
    if (rs_data.hasOwnProperty("cdi_era5")) {
      var cdi_era5_data_from_api = rs_data?.cdi_era5;
      set_innitial_selected_datasets_general(cdi_era5_data_from_api,
        layer_name_cdi_era5,
        null,
        setCdi_selected_dates_era5,
        setCurrent_cdi_era5,
        setCdi_latest_dates_era5,
        setCdi_dates_era5,
        "cdi_era5_geoserver"
        );

    // drought persistence
      var latest_year_era5 = cdi_era5_data_from_api.latest_year;
      var latest_month_era5 = cdi_era5_data_from_api.latest_month;
      var latest_dekad_era5 = cdi_era5_data_from_api['latest_dekad'];
    var drought_persistence_geoserver_link = `${geoserver}${maplibre_str}${layer_name_drought_persistence}${get_num_withzero(latest_month_era5)}${get_num_withzero(latest_dekad_era5)}_view&CQL_FILTER=year=${latest_year_era5}`;
    setDrought_persistence_selected_dates({
      year: latest_year_era5,
      month: getMonthName(latest_month_era5),
      dekad: get_dekad_name(get_num_withzero(latest_dekad_era5)),
    })
    setDrought_persistence_latest_dates({
      latest_year: latest_year_era5,
      latest_month: latest_month_era5,
      latest_dekad: get_num_withzero(latest_dekad_era5),
    });
    setDrought_persistence_dates({
      year: get_custom_list(cdi_era5_data_from_api.start_year, latest_year_era5),
      month: get_custom_list(1, latest_month_era5).map(getMonthName),
      dekad: get_custom_list(1, latest_dekad_era5, 10).map(get_dekad_name),
    });
    setCurrent_drought_persistence(drought_persistence_geoserver_link);
    }

   
  }

  useEffect(() => {
    // setCurrent_cdi();
    if (rs_data !== null) {
      set_initial_data(rs_data);
    }
  }, [rs_data]);

  //    Onchange functions  ==========

  const onchange_year_cdi = (e) => {
    var months = cdi_dates["month"];
    var dekads = cdi_dates["dekad"];

    if (cdi_latest_dates !== null) {
      if (
        parseInt(e.value, 10) !== parseInt(cdi_latest_dates["latest_year"], 10)
      ) {
        months = get_custom_list(1, 12);

        dekads = get_custom_list(1, 21, 10);

        months = months.map(getMonthName);
        dekads = dekads.map(get_dekad_name);
      } else {
        months = get_custom_list(1, cdi_latest_dates["latest_month"]);

        dekads = get_custom_list(1, cdi_latest_dates["latest_dekad"], 10);

        months = months.map(getMonthName);
        dekads = dekads.map(get_dekad_name);
      }
    }

    var selected_month = handle_selected_data(
      months,
      cdi_selected_dates["month"]
    );
    var selected_dekad = handle_selected_data(
      dekads,
      cdi_selected_dates["dekad"]
    );

    var cdi_geoserver_wms = `${geoserver}${maplibre_str}${layer_name_cdi}${months_obj[selected_month]}${list_dekads[selected_dekad]}_view&CQL_FILTER=year=${e.value}`;

    cdi_geoserver_wms = handle_wmslink(
      cdi_geoserver_wms,
      "cell",
      selected_country,
      selected_region
    );
    setCurrent_cdi({ cdi_geoserver: cdi_geoserver_wms });

    setCdi_selected_dates({
      year: e.value,
      month: selected_month,
      dekad: selected_dekad,
    });

    setCdi_dates((prevState) => ({
      ...prevState,
      month: months,
      dekad: dekads,
    }));
  };

  const onchange_month_cdi = (e) => {
    var cdi_geoserver_wms = `${geoserver}${maplibre_str}${layer_name_cdi}${
      months_obj[e.value]
    }${list_dekads[cdi_selected_dates["dekad"]]}_view&CQL_FILTER=year=${
      cdi_selected_dates["year"]
    }`;

    cdi_geoserver_wms = handle_wmslink(
      cdi_geoserver_wms,
      "cell",
      selected_country,
      selected_region
    );
    var dekads = cdi_dates["dekad"];
    
    if (cdi_latest_dates !== null) {
      if (
        parseInt(e.value, 10) !== parseInt(cdi_latest_dates["latest_month"], 10)
      ) {

        dekads = get_custom_list(1, 21, 10);

       
        dekads = dekads.map(get_dekad_name);
      } else {
     

        dekads = get_custom_list(1, cdi_latest_dates["latest_dekad"], 10);

  
        dekads = dekads.map(get_dekad_name);
      }
    }

    var selected_dekad = handle_selected_data(
      dekads,
      cdi_selected_dates["dekad"]
    );


    setCurrent_cdi({ cdi_geoserver: cdi_geoserver_wms });
    setCdi_dates((prevState) => ({
      ...prevState,
      dekad: dekads,
    }));

    setCdi_selected_dates({
      year: cdi_selected_dates["year"],
      month: e.value,
      dekad: selected_dekad,
    });
  };
  const onchange_dekad_cdi = (e) => {
    var cdi_geoserver_wms = `${geoserver}${maplibre_str}${layer_name_cdi}${
      months_obj[cdi_selected_dates["month"]]
    }${list_dekads[e.value]}_view&CQL_FILTER=year=${
      cdi_selected_dates["year"]
    }`;

    cdi_geoserver_wms = handle_wmslink(
      cdi_geoserver_wms,
      "cell",
      selected_country,
      selected_region
    );

    setCurrent_cdi({ cdi_geoserver: cdi_geoserver_wms });


    setCdi_selected_dates({
      year: cdi_selected_dates["year"],
      month: cdi_selected_dates["month"],
      dekad: e.value,
    });
  };

  // onchange cdi era 5 

  const handle_cdi_era5_wmslink = (selected_dates) => {
    var cdi_era5_geoserver_wms = `${geoserver}${maplibre_str}${layer_name_cdi_era5}${months_obj[selected_dates["month"]]}${list_dekads[selected_dates["dekad"]]}_view&CQL_FILTER=year=${selected_dates["year"]}`;
    cdi_era5_geoserver_wms = handle_wmslink(
      cdi_era5_geoserver_wms,
      "corr_cell",
      selected_country,
      selected_region
    );

    setCurrent_cdi_era5({ cdi_era5_geoserver: cdi_era5_geoserver_wms });

  }

  const getAllowedMonthsEra5 = (yearValue) => {
    if (cdi_latest_dates_era5 === null) {
      return get_custom_list(1, 12).map(getMonthName);
    }

    const isLatestYear = parseInt(yearValue, 10) === parseInt(cdi_latest_dates_era5.latest_year, 10);
    const maxMonth = isLatestYear ? parseInt(cdi_latest_dates_era5.latest_month, 10) : 12;

    return get_custom_list(1, maxMonth).map(getMonthName);
  };

  const getAllowedDekadsEra5 = (yearValue, monthValue) => {
    if (cdi_latest_dates_era5 === null) {
      return get_custom_list(1, 21, 10).map(get_dekad_name);
    }

    const isLatestYear = parseInt(yearValue, 10) === parseInt(cdi_latest_dates_era5.latest_year, 10);
    if (!isLatestYear) {
      return get_custom_list(1, 21, 10).map(get_dekad_name);
    }

    const selectedMonthNum = parseInt(months_obj[monthValue], 10);
    const latestMonthNum = parseInt(cdi_latest_dates_era5.latest_month, 10);

    if (selectedMonthNum === latestMonthNum) {
      const latestDekadCode = parseInt(list_dekads[cdi_latest_dates_era5.latest_dekad], 10);
      return get_custom_list(1, latestDekadCode, 10).map(get_dekad_name);
    }

    return get_custom_list(1, 21, 10).map(get_dekad_name);
  };

  const onchnage_year_cdi_era5 = (e)=>{
    const nextMonths = getAllowedMonthsEra5(e.value);
    const nextMonth = handle_selected_data(nextMonths, cdi_selected_dates_era5.month);
    const nextDekads = getAllowedDekadsEra5(e.value, nextMonth);
    const nextDekad = handle_selected_data(nextDekads, cdi_selected_dates_era5.dekad);
    const nextSelectedDates = {
      year: e.value,
      month: nextMonth,
      dekad: nextDekad,
    };

    setCdi_dates_era5((prevState) => ({
      ...prevState,
      month: nextMonths,
      dekad: nextDekads,
    }));
    setCdi_selected_dates_era5(nextSelectedDates);
    handle_cdi_era5_wmslink(nextSelectedDates);

  }
  const onchange_month_cdi_era5 = (e) =>{
    const nextDekads = getAllowedDekadsEra5(cdi_selected_dates_era5.year, e.value);
    const nextDekad = handle_selected_data(nextDekads, cdi_selected_dates_era5.dekad);
    const nextSelectedDates = {
      year: cdi_selected_dates_era5.year,
      month: e.value,
      dekad: nextDekad,
    };

    setCdi_dates_era5((prevState) => ({
      ...prevState,
      dekad: nextDekads,
    }));
    setCdi_selected_dates_era5(nextSelectedDates);
    handle_cdi_era5_wmslink(nextSelectedDates);
  }
  const onchange_dekad_cdi_era5= (e) =>{
    const nextSelectedDates = {
      ...cdi_selected_dates_era5,
      dekad: e.value,
    };

    setCdi_selected_dates_era5(nextSelectedDates)
    handle_cdi_era5_wmslink(nextSelectedDates)
  }

  const cdiEra5_onInfoClick = () =>{
    handleInfoClickGeneral(isDroughtModalVisibleCdiEra5,setDroughtModalVisibleCdiEra5,
      setIsLoadingCdiInfoEra5,setCdi_info_era5,"cdi_era")
  }

  const getAllowedMonthsDroughtPersistence = (yearValue) => {
    if (drought_persistence_latest_dates === null) {
      return get_custom_list(1, 12).map(getMonthName);
    }

    const isLatestYear = parseInt(yearValue, 10) === parseInt(drought_persistence_latest_dates.latest_year, 10);
    const maxMonth = isLatestYear ? parseInt(drought_persistence_latest_dates.latest_month, 10) : 12;

    return get_custom_list(1, maxMonth).map(getMonthName);
  };

  const getAllowedDekadsDroughtPersistence = (yearValue, monthValue) => {
    if (drought_persistence_latest_dates === null) {
      return get_custom_list(1, 21, 10).map(get_dekad_name);
    }

    const isLatestYear = parseInt(yearValue, 10) === parseInt(drought_persistence_latest_dates.latest_year, 10);
    if (!isLatestYear) {
      return get_custom_list(1, 21, 10).map(get_dekad_name);
    }

    const selectedMonthNum = parseInt(months_obj[monthValue], 10);
    const latestMonthNum = parseInt(drought_persistence_latest_dates.latest_month, 10);

    if (selectedMonthNum === latestMonthNum) {
      const latestDekadCode = parseInt(drought_persistence_latest_dates.latest_dekad, 10);
      return get_custom_list(1, latestDekadCode, 10).map(get_dekad_name);
    }

    return get_custom_list(1, 21, 10).map(get_dekad_name);
  };

  const handle_drought_persistence_wmslink = (selected_dates) => {
    var geosever_link = `${geoserver}${maplibre_str}${layer_name_drought_persistence}${months_obj[selected_dates.month]}${list_dekads[selected_dates.dekad]}_view&CQL_FILTER=year=${selected_dates.year}`;
    setCurrent_drought_persistence(geosever_link);
  };

  const onchnage_year_drought_persistence = (e) =>{
    const nextMonths = getAllowedMonthsDroughtPersistence(e.value);
    const nextMonth = handle_selected_data(nextMonths, drought_persistence_selected_dates.month);
    const nextDekads = getAllowedDekadsDroughtPersistence(e.value, nextMonth);
    const nextDekad = handle_selected_data(nextDekads, drought_persistence_selected_dates.dekad);
    const nextSelectedDates = {
      year: e.value,
      month: nextMonth,
      dekad: nextDekad,
    };

    setDrought_persistence_dates((prevState) => ({
      ...prevState,
      month: nextMonths,
      dekad: nextDekads,
    }));
    setDrought_persistence_selected_dates(nextSelectedDates);
    handle_drought_persistence_wmslink(nextSelectedDates);
  }

  const onchnage_month_drought_persistence = (e) =>{
    const nextDekads = getAllowedDekadsDroughtPersistence(drought_persistence_selected_dates.year, e.value);
    const nextDekad = handle_selected_data(nextDekads, drought_persistence_selected_dates.dekad);
    const nextSelectedDates = {
      year: drought_persistence_selected_dates.year,
      month: e.value,
      dekad: nextDekad,
    };

    setDrought_persistence_dates((prevState) => ({
      ...prevState,
      dekad: nextDekads,
    }));
    setDrought_persistence_selected_dates(nextSelectedDates)
    handle_drought_persistence_wmslink(nextSelectedDates);
  }

   const onchnage_dekad_drought_persistence = (e) =>{
    const nextSelectedDates = {
      ...drought_persistence_selected_dates,
      dekad: e.value,
    };

    setDrought_persistence_selected_dates(nextSelectedDates)
    handle_drought_persistence_wmslink(nextSelectedDates);
   }  

  const droughtPersistence_onInfoClick = () =>{
    handleInfoClickGeneral(isDroughtModalVisibleDroughtPersistence,setDroughtModalVisibleDroughtPersistence,
      setIsLoadingDroughtPersistenceInfo,setDroughtPersistenceInfo,"drought-persist")
  }

  const customoptions = (anArray) => {
    // returns the options for selection object
    var opt = anArray.map((item) => {
      return { value: item, label: item };
    });
    return opt;
  };

  // set wms to filter to country

  const get_select_element = (
    customoptions,
    array_options,
    onChange,
    placeholder,
    state = false,
    disable = false
  ) => {
    if (state !== false) {
      return (
        <Select
          className="select-indicator"
          classNamePrefix="select-controls-indicators"
          options={customoptions(array_options)}
          placeholder={placeholder}
          value={placeholder}
          //   value = 'Select Country'
          onChange={onChange}
          // onSelectResetsInput={true}
          isSearchable={true}
          isDisabled={disable}
        ></Select>
      );
    }
  };

  useEffect(() => {}, [
    cdi_check,
    cdi_selected_dates,
    monthly_precipitation_check,
    cdi_info,
  ]);

 const download_params = {
  product: "cdi",
  year: cdi_selected_dates["year"],
  month: cdi_selected_dates["month"],
  dekad: cdi_selected_dates["dekad"],
 }


  return (
    <div>
      <div className="combined-drought-indicator">
        <p className="Indicator-names">COMBINED DROUGHT INDICATOR (CDI)</p>


        {selection_component(()=> oncheckGeneral(cdi_check,setCdi_check),
      cdi_check,handleInfoClick, "10-day CDI", isDroughtModalVisible,
      isLoadingCdiInfo, cdi_info, cdi_selected_dates,cdi_dates,
      onchange_year_cdi,onchange_month_cdi, onchange_dekad_cdi,"dekad", null, {download: true, params: download_params})}

       {selection_component(()=> oncheckGeneral(cdi_era5_check,setCdi_era5_check),
      cdi_era5_check,cdiEra5_onInfoClick, "CDI based on SPI ERA5", isDroughtModalVisibleCdiEra5,
      isLoadingCdiInfoEra5, cdi_info_era5, cdi_selected_dates_era5,cdi_dates_era5,
      onchnage_year_cdi_era5,onchange_month_cdi_era5, onchange_dekad_cdi_era5,"dekad", null, {download: true, params:{product:"cdi_era5",
       year: cdi_selected_dates_era5?.year, month: cdi_selected_dates_era5?.month, dekad: cdi_selected_dates_era5?.dekad}} )}


        {selection_component(()=> oncheckGeneral(drought_persistence_check,setDrought_persistence_check),
        drought_persistence_check, droughtPersistence_onInfoClick, "Drought Persistence", isDroughtModalVisibleDroughtPersistence,
        isLoadingDroughtPersistenceInfo, DroughtPersistenceInfo, drought_persistence_selected_dates, drought_persistence_dates,
        onchnage_year_drought_persistence, onchnage_month_drought_persistence, onchnage_dekad_drought_persistence, "dekad",
         )}

        <div className="tabs is-centered">
        <ul>

        </ul>
        </div>
      </div>

      <div className="combined-monitoring-and-forecast">
        <p className="Indicator-names">COMBINED MONITORING & FORECAST</p>

        <CombinedHazard
          source="era5"
          label="Combined Monitoring & Forecast Hazard (ERA5)"
          combined_hazard_check={combined_hazard_era5_check}
          setCombined_hazard_check={setCombined_hazard_era5_check}
          setCurrent_combined_hazard={setCurrent_combined_hazard_era5}
        />
        <CombinedHazard
          source="gpcc"
          label="Combined Monitoring & Forecast Hazard (GPCC)"
          combined_hazard_check={combined_hazard_gpcc_check}
          setCombined_hazard_check={setCombined_hazard_gpcc_check}
          setCurrent_combined_hazard={setCurrent_combined_hazard_gpcc}
        />

        <CombinedForecast
          source="era5"
          label="Combined Drought Forecast (ERA5)"
          combined_forecast_check={combined_forecast_era5_check}
          setCombined_forecast_check={setCombined_forecast_era5_check}
          setCurrent_combined_forecast={setCurrent_combined_forecast_era5}
        />
        <CombinedForecast
          source="gpcc"
          label="Combined Drought Forecast (GPCC)"
          combined_forecast_check={combined_forecast_gpcc_check}
          setCombined_forecast_check={setCombined_forecast_gpcc_check}
          setCurrent_combined_forecast={setCurrent_combined_forecast_gpcc}
        />

        <div className="tabs is-centered">
        <ul>

        </ul>
        </div>
      </div>

      <div className="combined-drought-indicator">
        <Precipitation
          get_select_element={get_select_element}
          customoptions={customoptions}
          monthly_precipitation_check={monthly_precipitation_check}
          setMonthly_recipitation_check={setMonthly_recipitation_check}
          rs_data={rs_data}
          precipitation_check={precipitation_check}
          setPrecipitation_check={setPrecipitation_check}
          setCurrent_vector={setCurrent_vector}
          setCurrent_spi={setCurrent_spi}
          setSpi_legend_url={setSpi_legend_url}
          months={months}
          selected_spi_dates={selected_spi_dates}
          setSelected_spi_dates={setSelected_spi_dates}
          get_filtered_wms_spi={get_filtered_wms_spi}
          selected_country={selected_country}
          base_url={base_url}
          setCurrent_monthly_precipitation_gpcc={
            setCurrent_monthly_precipitation_gpcc
          }
          setGpcc_monthly_precipitation_legend_url={
            setGpcc_monthly_precipitation_legend_url
          }
          selected_region={selected_region}
          unwdc_check={unwdc_check}
          setUnwdc_check={setUnwdc_check}
          setCurrent_unwdc={setCurrent_unwdc}
          setCurrent_spi_era5={setCurrent_spi_era5}
          checked_spi_era5={checked_spi_era5}
           setChecked_spi_era5={setChecked_spi_era5}
          longrange_forecast_check={longrange_forecast_check}
          setLongrange_forecast_check={setLongrange_forecast_check}
          setCurrent_longrange_forecast={setCurrent_longrange_forecast}
        />

        <Vegetation
          get_select_element={get_select_element}
          customoptions={customoptions}
          ndvi_check={ndvi_check}
          setNdvi_check={setNdvi_check}
          rs_data={rs_data}
          get_years={get_years}
          months={months}
          setCurrent_fapar_anomaly={setCurrent_fapar_anomaly}
          fapar_anomaly_check={fapar_anomaly_check}
          setFapar_anomaly_check={setFapar_anomaly_check}
          selected_country={selected_country}
          get_filtered_wms={get_filtered_wms}
          setFapar_anomaly_legend_url={setFapar_anomaly_legend_url}
          fapar_absorbed_check={fapar_absorbed_check}
          setFapar_absorbed_check={setFapar_absorbed_check}
          base_url={base_url}
          setCurrent_fapar_absorbed={setCurrent_fapar_absorbed}
          setFapar_absorbed_legend_url={setFapar_absorbed_legend_url}
          selected_region={selected_region}
          request_str_modis_ndvi={request_str_modis_ndvi}
          setRequest_str_modis_ndvi={setRequest_str_modis_ndvi}
          setCurrent_ndvi={setCurrent_ndvi}
        />
        <div className="tabs is-centered">
        <ul>
         
        </ul>
        </div>
      

        <Soil
          get_select_element={get_select_element}
          customoptions={customoptions}
          sma_check={sma_check}
          setSma_check={setSma_check}
          rs_data={rs_data}
          setCurrent_sma={setCurrent_sma}
          selected_region={selected_region}
          selected_country={selected_country}
          setLegend_url_sma={setLegend_url_sma}
        />

        <div className="tabs is-centered">
                <ul>
                
                </ul>
          </div>

        <GeographicBackground
          get_select_element={get_select_element}
          customoptions={customoptions}
          temp_class_check={temp_class_check}
          setTemp_class_check={setTemp_class_check}
          base_url={base_url}
          koppen_climate_clas_check={koppen_climate_clas_check}
          setKoppen_climate_clas_check={setKoppen_climate_clas_check}
        />

        <div className="tabs is-centered">
                <ul>
                
                </ul>
          </div>

        <ProtectedAreas
          get_select_element={get_select_element}
          customoptions={customoptions}
          protetect_areas_check={protetect_areas_check}
          setProtetect_areas_check={setProtetect_areas_check}
          base_url={base_url}
          current_protected_areas={current_protected_areas}
          setCurrent_protected_areas={setCurrent_protected_areas}
        />


      </div>
      <div className="tabs is-centered">
        <ul>

        </ul>
      </div>
    </div>
  );
};

export default Indicators;
